import DetailsBasel from "pages/Application/ExportLicense/DetailsBasel"
import BaseApplication from "pages/BaseApplication"
import { useEffect, useState } from "react"

import ReviewController from "controllers/ReviewController"
import HeadForm from "../Forms/ReviewHead.form"
import DetailsRotterdam from "pages/Application/ExportLicense/DetailsRotterdam"
import DetailsPlasticBags from "../../PlasticBags/DetailsPlasticBags"
import DisposalDetails from "pages/Application/Disposal/DisposalDetails"
import DetailDeliveryPartner from "pages/Application/DeliveryPartner/Details"
import DetailsAccreditation from "pages/Application/AccreditationRequest/Details"
import DetailsNoObjection from "pages/Application/NoObjectionRequest/Details"
import DetailsEnvironmentalAudit from "pages/Application/EnvironmentalAudit/Details"
import HeadFormEnvAudit from "../Forms/ReviewHeadEnvAudit.form"
import HeadFormAccreditation from "../Forms/ReviewHeadAccreditation.form"
import HeadFormDeliveryPartner from "../Forms/ReviewHeadDeliveryPartner.form"
import HeadFormNoObjection from "../Forms/ReviewHeadNoObjection.form"

const reviewController = new ReviewController()

const ReviewHeadExport = props => {
  const [details, setdetails] = useState()
  const [loading, setloading] = useState(false)
  const [success, setsuccess] = useState(false)
  const [error, seterror] = useState(false)
  const [message, setmessage] = useState("")
  const [headform, setheadform] = useState()
  const [serviceType, setserviceType] = useState("")

  useEffect(() => {
    if (serviceType == "environmental-audit") {
      setheadform(
        <HeadFormEnvAudit
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "accreditation") {
      setheadform(
        <HeadFormAccreditation
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "delivery-partner") {
      setheadform(
        <HeadFormDeliveryPartner
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "no-objection") {
      setheadform(
        <HeadFormNoObjection
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }

    if (serviceType == "auth-plastics") {
      setheadform(
        <HeadForm
          success={success}
          error={error}
          loading={true}
          message={message}
          appDetails={props.appDetails}
        />
      )
    }
  }, [loading])
  useEffect(() => {
    setheadform(
      <HeadForm
        success={success}
        error={error}
        loading={loading}
        message={message}
        appDetails={props.appDetails}
      />
    )
    // console.log("app details ---> ", props.appDetails)
    if (props.appDetails.basel_convention) {
      setdetails(<DetailsBasel appDetails={props.appDetails} />)
    } else if (props.appDetails.auth_plastic_bags) {
      setserviceType("auth-plastics")
      setdetails(<DetailsPlasticBags appDetails={props.appDetails} />)
    } else if (props.appDetails.guidance_disposal) {
      setdetails(<DisposalDetails appDetails={props.appDetails} />)
    } else if (props.appDetails.delivery_partner_service_request) {
      setserviceType("delivery-partner")
      setheadform(
        <HeadFormDeliveryPartner
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailDeliveryPartner appDetails={props.appDetails} />)
    } else if (props.appDetails.accreditation_request) {
      setserviceType("accreditation")
      setheadform(
        <HeadFormAccreditation
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsAccreditation appDetails={props.appDetails} />)
    } else if (props.appDetails.no_objection_letter_request) {
      setserviceType("no-objection")
      setheadform(
        <HeadFormNoObjection
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsNoObjection appDetails={props.appDetails} />)
    } else if (props.appDetails.environmental_audit_request) {
      setserviceType("environmental-audit")
      setheadform(
        <HeadFormEnvAudit
          success={success}
          error={error}
          loading={loading}
          message={message}
          appDetails={props.appDetails}
        />
      )
      setdetails(<DetailsEnvironmentalAudit appDetails={props.appDetails} />)
    } else {
      setdetails(<DetailsRotterdam appDetails={props.appDetails} />)
    }
  }, [])

  async function submitReview(values) {
    if (confirm("Do you want to proceed with selected decision?")) {
      setloading(true)
      let response = await reviewController.reviewHead(values)

      if (response.status) {
        setloading(false)
        setsuccess(true)
        seterror(false)
        setmessage(response.message)

        if (serviceType == "auth-plastics") {
          setheadform(
            <HeadForm
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "environmental-audit") {
          setheadform(
            <HeadFormEnvAudit
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "no-objection") {
          setheadform(
            <HeadFormNoObjection
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "accreditation") {
          setheadform(
            <HeadFormAccreditation
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "delivery-partner") {
          setheadform(
            <HeadFormDeliveryPartner
              success={true}
              error={false}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      } else {
        setloading(false)
        setsuccess(false)
        seterror(true)
        setmessage(response.message)

        if (serviceType == "auth-plastics") {
          setheadform(
            <HeadForm
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "environmental-audit") {
          setheadform(
            <HeadFormEnvAudit
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "accreditation") {
          setheadform(
            <HeadFormAccreditation
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "delivery-partner") {
          setheadform(
            <HeadFormDeliveryPartner
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }

        if (serviceType == "no-objection") {
          setheadform(
            <HeadFormNoObjection
              success={false}
              error={true}
              loading={false}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      }
    }
  }

  return (
    <>
      <BaseApplication
        title="Department Review Application"
        attachments={props.appDetails.application_attachments}
        appDetails={details}
        submit={submitReview}
        formComponent={headform}
        applicationData={props.appDetails}
      />
    </>
  )
}

export default ReviewHeadExport
